import React, { useState, useEffect } from "react";
import MinDataService from "../services/MinService";

const Min = props => {
  const initialMinState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentMin, setCurrentMin] = useState(initialMinState);
  const [message, setMessage] = useState("");

  const getMin = id => {
    MinDataService.get(id)
      .then(response => {
        setCurrentMin(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getMin(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentMin({ ...currentMin, [name]: value });
  };

  const updateMin = () => {
    MinDataService.update(currentMin.id, currentMin)
      .then(response => {
        console.log(response.data);
        setMessage("Minutes transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteMin = () => {
    MinDataService.remove(currentMin.id)
      .then(response => {
        console.log(response.data);
        props.history.push("/min");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentMin ? (
        <div className="edit-form">
          <h4>Minutes Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentMin.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentMin.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentMin.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteMin}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateMin}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on Minutes Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Min;
